import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import "../styles/Purchases.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShoppingCart,
    faUser,
    faPhone,
    faMapMarkerAlt,
    faCalendarAlt,
    faFileInvoice,
    faBox,
    faRupeeSign,
    faTag,
    faBalanceScale,
    faDollarSign,
    faCalculator,
    faExclamationTriangle,
    faPlus,
    faMinus,
    faTrash,
    faSave,
    faTimes,
    faSpinner,
    faCheckCircle,
    faExclamationCircle,
    faSearch,
    faBarcode,
    faQrcode,
    faCreditCard,
    faMoneyBill,
    faUniversity,
    faWallet,
    faPercent,
    faReceipt,
    faChevronDown,
    faChevronUp,
    faBoxes,
    faUsers,
    faStore,
    faUserPlus,
    faClock
} from '@fortawesome/free-solid-svg-icons';

// ==============================================
// Translation Utility
// ==============================================
const createPosTranslator = () => {
    let cache = new Map();
    let translationListeners = new Set();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_pos_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_pos_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const urduTranslations = {
        posOrder: 'آرڈر فارم',
        customerInfo: 'گاہک کی معلومات',
        customerName: 'گاہک کا نام',
        customerPhone: 'فون نمبر',
        customerAddress: 'پتہ',
        searchCustomer: 'گاہک تلاش کریں...',
        newCustomer: 'نیا گاہک',
        existingCustomer: 'موجودہ گاہک',
        addNewCustomer: 'نیا گاہک شامل کریں',
        employee: 'ملازم',
        selectEmployee: 'ملازم منتخب کریں',
        orderItems: 'آرڈر کی اشیاء',
        addProduct: 'مصنوعات شامل کریں',
        searchProducts: 'مصنوعات تلاش کریں (نام، بیچ، بارکوڈ)',
        scanBarcode: 'بارکوڈ اسکین کریں',
        selectProduct: 'مصنوعات منتخب کریں',
        noProductsFound: 'کوئی مصنوعات نہیں ملی',
        outOfStock: 'اسٹک ختم',
        lowStock: 'کم اسٹاک',
        availableStock: 'دستیاب',
        items: 'اشیاء',
        addItem: 'شامل کریں',
        productName: 'مصنوعات',
        batchNumber: 'بیچ نمبر',
        unit: 'یونٹ',
        price: 'قیمت',
        quantity: 'مقدار',
        total: 'کل',
        remove: 'ہٹائیں',
        stock: 'اسٹاک',
        calculations: 'حساب',
        subtotal: 'ذیلی کل',
        tax: 'ٹیکس',
        discount: 'ڈسکاؤنٹ',
        grandTotal: 'کل رقم',
        paidAmount: 'ادا کردہ',
        balance: 'بقایا',
        paymentMethod: 'ادائیگی کا طریقہ',
        cash: 'نقد',
        card: 'کارڈ',
        bankTransfer: 'بینک ٹرانسفر',
        easyPaisa: 'ایزی پیسہ',
        jazzCash: 'جاز کیش',
        other: 'دیگر',
        paymentStatus: 'ادائیگی کی حالت',
        paid: 'ادا شدہ',
        partial: 'جزوی',
        unpaid: 'ادا نہیں',
        placeOrder: 'آرڈر جمع کریں',
        clear: 'صاف کریں',
        saving: 'محفوظ ہو رہا ہے...',
        loading: 'لوڈ ہو رہا ہے...',
        orderPlaced: 'آرڈر کامیابی سے جمع ہو گیا!',
        orderFailed: 'آرڈر جمع کرنے میں ناکامی',
        duplicateSubmission: 'ڈپلیکیٹ جمع کرائی گئی۔ براہ کرم انتظار کریں۔',
        noShopSelected: 'کوئی دکان منتخب نہیں۔ براہ کرم پہلے دکان منتخب کریں۔',
        customerSelected: 'گاہک منتخب کر لیا گیا',
        customerCreated: 'نیا گاہک کامیابی سے شامل ہو گیا',
        itemsRequired: 'کم از کم ایک آئٹم ضروری ہے',
        quantityExceedsStock: 'مقدار دستیاب اسٹاک سے زیادہ ہے',
        invalidQuantity: 'براہ کرم درست مقدار درج کریں',
        invalidPrice: 'براہ کرم درست قیمت درج کریں',
        piece: 'ٹکڑا',
        box: 'ڈبہ',
        packet: 'پیکٹ',
        kg: 'کلوگرام',
        gram: 'گرام',
        liter: 'لیٹر',
        ml: 'ملی لیٹر',
        dozen: 'درجن',
        selectUnit: 'یونٹ منتخب کریں',
        success: 'کامیابی',
        error: 'خرابی',
        warning: 'انتباہ',
        todayOrders: "آج کے آرڈرز",
        totalOrders: 'کل آرڈرز',
        totalAmount: 'کل رقم',
        totalPaid: 'کل ادائیگی',
        totalBalance: 'کل بقایا',
        notes: 'نوٹس',
        orderStatus: 'آرڈر کی حالت',
        pending: 'زیر التواء',
        completed: 'مکمل',
        cancelled: 'منسوخ',
        invoiceNo: 'انوائس نمبر',
        orderNo: 'آرڈر نمبر',
        orderDate: 'تاریخ',
        orderTime: 'وقت'
    };

    const defaultTexts = {
        posOrder: 'POS Order Form',
        customerInfo: 'Customer Information',
        customerName: 'Customer Name',
        customerPhone: 'Phone Number',
        customerAddress: 'Address',
        searchCustomer: 'Search customer...',
        newCustomer: 'New Customer',
        existingCustomer: 'Existing Customer',
        addNewCustomer: 'Add New Customer',
        employee: 'Employee',
        selectEmployee: 'Select Employee',
        orderItems: 'Order Items',
        addProduct: 'Add Product',
        searchProducts: 'Search products (name, batch, barcode)',
        scanBarcode: 'Scan Barcode',
        selectProduct: 'Select Product',
        noProductsFound: 'No products found',
        outOfStock: 'Out of Stock',
        lowStock: 'Low Stock',
        availableStock: 'Available',
        items: 'Items',
        addItem: 'Add Item',
        productName: 'Product',
        batchNumber: 'Batch',
        unit: 'Unit',
        price: 'Price',
        quantity: 'Qty',
        total: 'Total',
        remove: 'Remove',
        stock: 'Stock',
        calculations: 'Calculations',
        subtotal: 'Subtotal',
        tax: 'Tax',
        discount: 'Discount',
        grandTotal: 'Grand Total',
        paidAmount: 'Paid Amount',
        balance: 'Balance',
        paymentMethod: 'Payment Method',
        cash: 'Cash',
        card: 'Card',
        bankTransfer: 'Bank Transfer',
        easyPaisa: 'EasyPaisa',
        jazzCash: 'JazzCash',
        other: 'Other',
        paymentStatus: 'Payment Status',
        paid: 'Paid',
        partial: 'Partial',
        unpaid: 'Unpaid',
        placeOrder: 'Place Order',
        clear: 'Clear',
        saving: 'Saving...',
        loading: 'Loading...',
        orderPlaced: 'Order placed successfully!',
        orderFailed: 'Failed to place order',
        duplicateSubmission: 'Duplicate submission detected. Please wait.',
        noShopSelected: 'No shop selected. Please select a shop first.',
        customerSelected: 'Customer selected',
        customerCreated: 'New customer created successfully',
        itemsRequired: 'At least one item is required',
        quantityExceedsStock: 'Quantity exceeds available stock',
        invalidQuantity: 'Please enter a valid quantity',
        invalidPrice: 'Please enter a valid price',
        piece: 'Piece',
        box: 'Box',
        packet: 'Packet',
        kg: 'Kilogram',
        gram: 'Gram',
        liter: 'Liter',
        ml: 'Milliliter',
        dozen: 'Dozen',
        selectUnit: 'Select unit',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        todayOrders: "Today's Orders",
        totalOrders: 'Total Orders',
        totalAmount: 'Total Amount',
        totalPaid: 'Total Paid',
        totalBalance: 'Total Balance',
        notes: 'Notes',
        orderStatus: 'Order Status',
        pending: 'Pending',
        completed: 'Completed',
        cancelled: 'Cancelled',
        invoiceNo: 'Invoice No',
        orderNo: 'Order No',
        orderDate: 'Date',
        orderTime: 'Time'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') return defaultTexts;
        if (lang === 'ur') return urduTranslations;
        
        const translations = {};
        const promises = [];
        
        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    (async () => {
                        const translated = defaultTexts[key];
                        cache.set(cacheKey, translated);
                        translations[key] = translated;
                        return translated;
                    })()
                );
            }
        });
        
        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }
        
        return translations;
    };

    const addListener = (callback) => {
        translationListeners.add(callback);
    };

    const removeListener = (callback) => {
        translationListeners.delete(callback);
    };

    loadFromCache();

    return {
        getTranslations,
        addListener,
        removeListener
    };
};

const posTranslator = createPosTranslator();

// ==============================================
// Toast Notification Component
// ==============================================
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationCircle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success':
                return translations?.success || 'Success';
            case 'error':
                return translations?.error || 'Error';
            case 'warning':
                return translations?.warning || 'Warning';
            default:
                return '';
        }
    };

    if (!toast.show) return null;

    const opacity = Math.max(toast.progress / 100, 0.1);

    return (
        <div
            className={`toast-notification ${toast.type} ${toast.direction === 'rtl' ? 'toast-rtl' : 'toast-ltr'}`}
            style={{ opacity }}
        >
            <div className="toast-content">
                <div className="toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="toast-text">
                    <div className="toast-title">
                        {getTitleForType(toast.type)}
                    </div>
                    <div className="toast-message">
                        {toast.message}
                    </div>
                </div>
                <button
                    className="toast-close"
                    onClick={() => setToast(prev => ({ ...prev, show: false }))}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className="toast-timer">
                <div
                    className="toast-progress-bar"
                    style={{
                        width: `${toast.progress}%`,
                        transition: 'width 0.1s linear'
                    }}
                ></div>
                <div className="toast-countdown">
                    {toast.timeLeft}s
                </div>
            </div>
        </div>
    );
};

// ==============================================
// Items Table Component - EXACT CLASS NAMES as sell.js
// ==============================================
const ItemsTable = ({
    items,
    onItemChange,
    onRemove,
    onAdd,
    errors,
    disabled,
    translations,
    isRTL
}) => {
    const units = [
        { value: 'piece', label: translations?.piece || 'Piece' },
        { value: 'box', label: translations?.box || 'Box' },
        { value: 'packet', label: translations?.packet || 'Packet' },
        { value: 'kg', label: translations?.kg || 'Kilogram' },
        { value: 'gram', label: translations?.gram || 'Gram' },
        { value: 'liter', label: translations?.liter || 'Liter' },
        { value: 'ml', label: translations?.ml || 'Milliliter' },
        { value: 'dozen', label: translations?.dozen || 'Dozen' },
        { value: 'dabba', label: 'Dabba' },
        { value: 'burai', label: 'Burai' }
    ];

    const calculateTotal = (price, quantity) => {
        const p = parseFloat(price) || 0;
        const q = parseFloat(quantity) || 0;
        return (p * q).toFixed(2);
    };

    return (
        <div className="items-table-container">
            <div className="table-header-actions">
                <h4>
                    <FontAwesomeIcon icon={faBoxes} className="header-icon-only" />
                    {translations?.items || 'Items'}
                </h4>
                <button type="button" className="btn-add-item-table" onClick={onAdd} disabled={disabled}>
                    <FontAwesomeIcon icon={faPlus} />
                    <span>{translations?.addItem || 'Add Item'}</span>
                </button>
            </div>
            <div className="table-wrapper">
                <table className="items-table">
                    <thead>
                        <tr>
                            <th className="product-col">
                                {translations?.productName || 'Product'} <span className="required">*</span>
                            </th>
                            <th className="batch-col">
                                {translations?.batchNumber || 'Batch'}
                            </th>
                            <th className="unit-col">
                                {translations?.unit || 'Unit'} <span className="required">*</span>
                            </th>
                            <th className="price-col">
                                {translations?.price || 'Price'} <span className="required">*</span>
                            </th>
                            <th className="qty-col">
                                {translations?.quantity || 'Qty'} <span className="required">*</span>
                            </th>
                            <th className="total-col">
                                {translations?.total || 'Total'}
                            </th>
                            <th className="action-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index} className={errors[`quantity_${index}`] ? 'error-row' : ''}>
                                <td>
                                    <div className="table-field">
                                        <input
                                            type="text"
                                            value={item.product_name}
                                            readOnly
                                            className="readonly-input"
                                            dir={isRTL ? 'rtl' : 'ltr'}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className="table-field">
                                        <input
                                            type="text"
                                            value={item.batch_no || ''}
                                            readOnly
                                            className="readonly-input"
                                            dir={isRTL ? 'rtl' : 'ltr'}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className="table-field">
                                        <select
                                            value={item.unit || 'piece'}
                                            onChange={(e) => onItemChange(index, 'unit', e.target.value)}
                                            disabled={disabled}
                                            dir={isRTL ? 'rtl' : 'ltr'}
                                            className={errors[`unit_${index}`] ? 'error' : ''}
                                        >
                                            <option value="">{translations?.selectUnit || 'Select'}</option>
                                            {units.map((unit) => (
                                                <option key={unit.value} value={unit.value}>
                                                    {unit.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </td>
                                <td>
                                    <div className="table-field">
                                        <input
                                            type="number"
                                            value={item.price}
                                            onChange={(e) => onItemChange(index, 'price', e.target.value)}
                                            step="0.01"
                                            min="0"
                                            placeholder="0.00"
                                            disabled={disabled}
                                            dir="ltr"
                                            className={errors[`price_${index}`] ? 'error' : ''}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className="table-field">
                                        <input
                                            type="number"
                                            value={item.quantity}
                                            onChange={(e) => onItemChange(index, 'quantity', e.target.value)}
                                            step="0.001"
                                            min="0.001"
                                            max={item.available_stock}
                                            placeholder="0.000"
                                            disabled={disabled}
                                            dir="ltr"
                                            className={errors[`quantity_${index}`] ? 'error' : ''}
                                        />
                                        <small className="stock-hint">
                                            {translations?.stock || 'Stock'}: {parseFloat(item.available_stock || 0).toFixed(2)} {item.unit}
                                        </small>
                                        {errors[`quantity_${index}`] && (
                                            <div className="table-error">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {errors[`quantity_${index}`]}
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    <div className="table-field">
                                        <input
                                            type="text"
                                            value={calculateTotal(item.price, item.quantity)}
                                            readOnly
                                            disabled
                                            className="readonly-input total-display"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        className="table-remove-btn"
                                        onClick={() => onRemove(index)}
                                        disabled={disabled || items.length === 1}
                                        title={translations?.remove || 'Remove'}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// ==============================================
// Employee Selector Component - EXACT CLASS NAMES as sell.js style
// ==============================================
const EmployeeSelector = ({ selectedEmployee, onSelectEmployee, shopId, translations, disabled }) => {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (shopId) {
            loadEmployees();
        }
    }, [shopId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const loadEmployees = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/employees.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_employees_list',
                    shop_id: shopId
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setEmployees(data.data || []);
            }
        } catch (error) {
            console.error('Error loading employees:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-group-modern customer-search-group" ref={dropdownRef}>
            <div className="input-container">
                <FontAwesomeIcon icon={faUsers} className="input-icon" />
                <div className={`employee-selector-input ${disabled ? 'disabled' : ''}`} onClick={() => !disabled && setShowDropdown(!showDropdown)}>
                    <div className="selected-value">
                        {selectedEmployee ? (
                            <span>{selectedEmployee.employee_name}</span>
                        ) : (
                            <span className="placeholder">{translations?.selectEmployee || 'Select Employee'}</span>
                        )}
                        <FontAwesomeIcon icon={showDropdown ? faChevronUp : faChevronDown} />
                    </div>
                </div>
                <label className="input-label">
                    {translations?.employee || 'Employee'}
                    <span className="required">*</span>
                </label>
                {loading && (
                    <div className="search-indicator">
                        <FontAwesomeIcon icon={faSpinner} spin />
                    </div>
                )}
            </div>
            {showDropdown && !disabled && (
                <div className="customer-search-dropdown">
                    {loading ? (
                        <div className="dropdown-loading"><FontAwesomeIcon icon={faSpinner} spin /> Loading...</div>
                    ) : employees.length === 0 ? (
                        <div className="dropdown-empty">No employees found</div>
                    ) : (
                        employees.map(emp => (
                            <div
                                key={emp.employeeid}
                                className={`customer-search-item ${selectedEmployee?.employeeid === emp.employeeid ? 'selected' : ''}`}
                                onClick={() => {
                                    onSelectEmployee(emp);
                                    setShowDropdown(false);
                                }}
                            >
                                <div className="customer-name">{emp.employee_name}</div>
                                {emp.position && (
                                    <div className="customer-phone">
                                        <FontAwesomeIcon icon={faUser} size="xs" />
                                        {emp.position}
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

// ==============================================
// Main POS Order Component
// ==============================================
const PosOrderForm = ({ orderId = null, onSuccess = null }) => {
    const { user, currentShop } = useAuth();

    const [shopId, setShopId] = useState(() => {
        return currentShop?.shop_id || localStorage.getItem('current_shop_id') || '';
    });

    const [formData, setFormData] = useState({
        order_date: new Date().toISOString().split('T')[0],
        order_time: new Date().toLocaleTimeString(),
        invoice_no: '',
        customer_id: null,
        customer_name: '',
        customer_phone: '',
        customer_address: '',
        employee_id: null,
        employee_name: '',
        subtotal: '0.00',
        tax: '0.00',
        tax_percent: '0.00',
        discount: '0.00',
        discount_type: 'fixed',
        discount_percent: '0.00',
        shipping: '0.00',
        grand_total: '0.00',
        amount_paid: '0.00',
        balance_due: '0.00',
        payment_method: 'cash',
        order_status: 'completed',
        notes: '',
        items: []
    });

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [translations, setTranslations] = useState({});
    const [isTranslating, setIsTranslating] = useState(false);

    // Customer search states - EXACT SAME as sell.js
    const [customerSearchResults, setCustomerSearchResults] = useState([]);
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
    const [searchingCustomer, setSearchingCustomer] = useState(false);
    const [newCustomerInfo, setNewCustomerInfo] = useState(null);
    const [showCustomerModal, setShowCustomerModal] = useState(false);

    // Product search states
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [searchingProducts, setSearchingProducts] = useState(false);

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        direction: 'ltr',
        progress: 100,
        timeLeft: 3
    });

    // Refs
    const toastTimerRef = useRef(null);
    const customerSearchRef = useRef(null);
    const productSearchRef = useRef(null);
    const searchTimeoutRef = useRef(null);

    // Show toast function - EXACT SAME as sell.js
    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) {
            clearInterval(toastTimerRef.current);
        }

        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const direction = isRTL ? 'rtl' : 'ltr';

        setToast({
            show: true,
            type,
            message,
            direction,
            progress: 100,
            timeLeft: 3
        });

        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;

            setToast(prev => ({
                ...prev,
                progress,
                timeLeft: parseFloat(timeLeft.toFixed(1))
            }));

            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);

        toastTimerRef.current = timer;
    }, [currentLanguage]);

    // Clean up timer
    useEffect(() => {
        return () => {
            if (toastTimerRef.current) {
                clearInterval(toastTimerRef.current);
            }
        };
    }, []);

    // Load translations
    const loadTranslations = useCallback(async (lang) => {
        if (!lang) return;

        setIsTranslating(true);
        try {
            const trans = await posTranslator.getTranslations(lang);
            setTranslations(trans);

            const isRTL = lang === 'ur' || lang === 'ar';
            document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
            document.body.dir = isRTL ? 'rtl' : 'ltr';
        } catch (error) {
            console.error('Error loading translations:', error);
        } finally {
            setIsTranslating(false);
        }
    }, []);

    // Setup language change listener
    useEffect(() => {
        loadTranslations(currentLanguage);

        const handleLanguageChange = () => {
            const newLang = localStorage.getItem('ourzest_language') || 'en';
            if (newLang !== currentLanguage) {
                setCurrentLanguage(newLang);
                loadTranslations(newLang);
            }
        };

        window.addEventListener('storage', handleLanguageChange);

        const intervalId = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 500);

        const translationListener = (lang) => {
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        posTranslator.addListener(translationListener);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            clearInterval(intervalId);
            posTranslator.removeListener(translationListener);
        };
    }, [currentLanguage, loadTranslations]);

    // Update shop when currentShop changes
    useEffect(() => {
        if (currentShop?.shop_id) {
            setShopId(currentShop.shop_id);
        }
    }, [currentShop]);

    // Generate invoice number
    useEffect(() => {
        if (!isEditMode) {
            const date = new Date();
            const invoiceNo = `INV-${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`;
            setFormData(prev => ({ ...prev, invoice_no: invoiceNo }));
        }
    }, [isEditMode]);

    // Load order data if in edit mode
    useEffect(() => {
        if (orderId) {
            setIsEditMode(true);
            loadOrderData(orderId);
        }
    }, [orderId]);

    // Calculate totals when items change
    useEffect(() => {
        calculateTotals();
    }, [formData.items, formData.tax_percent, formData.discount, formData.discount_type, formData.shipping]);

    // Click outside handlers
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (customerSearchRef.current && !customerSearchRef.current.contains(event.target)) {
                setShowCustomerDropdown(false);
            }
            if (productSearchRef.current && !productSearchRef.current.contains(event.target)) {
                setShowProductDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const loadOrderData = async (id) => {
        if (!shopId) return;
        setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pos_orders.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_record',
                    id: id,
                    shop_id: shopId
                })
            });
            const data = await response.json();
            if (data.status === 'success' && data.data) {
                const order = data.data;
                setFormData(prev => ({
                    ...prev,
                    order_date: order.order_date,
                    order_time: order.order_time,
                    invoice_no: order.invoice_no,
                    customer_id: order.customer_id,
                    customer_name: order.customer_name || '',
                    customer_phone: order.customer_phone || '',
                    customer_address: order.customer_address || '',
                    employee_id: order.employee_id,
                    employee_name: order.employee_name || '',
                    subtotal: order.subtotal,
                    tax: order.tax,
                    tax_percent: order.tax_percent,
                    discount: order.discount,
                    discount_type: order.discount_type,
                    discount_percent: order.discount_percent,
                    shipping: order.shipping,
                    grand_total: order.grand_total,
                    amount_paid: order.amount_paid,
                    balance_due: order.balance_due,
                    payment_method: order.payment_method,
                    order_status: order.order_status,
                    notes: order.notes || '',
                    items: order.items.map(item => ({
                        product_id: item.product_id,
                        product_name: item.product_name,
                        batch_no: item.batch_no,
                        barcode: item.barcode,
                        unit: item.unit,
                        price: item.price,
                        quantity: item.quantity,
                        available_stock: 999999
                    }))
                }));
            }
        } catch (error) {
            console.error('Error loading order:', error);
            showToast('error', 'Failed to load order data');
        } finally {
            setLoading(false);
        }
    };

    // Debounce function
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Customer search - EXACT SAME as sell.js
    const searchCustomers = useCallback(
        debounce(async (searchTerm) => {
            if (!searchTerm || searchTerm.length < 2 || !shopId) {
                setCustomerSearchResults([]);
                setShowCustomerDropdown(false);
                return;
            }

            setSearchingCustomer(true);

            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }

            try {
                const response = await fetch('https://ourzestapp.online/oz_backend/sell.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        action: 'search_customer',
                        search_term: searchTerm,
                        shop_id: shopId
                    })
                });

                const data = await response.json();
                if (data.status === 'success') {
                    setCustomerSearchResults(data.data || []);
                    setShowCustomerDropdown(data.data && data.data.length > 0);
                } else {
                    setCustomerSearchResults([]);
                    setShowCustomerDropdown(false);
                }
            } catch (error) {
                console.error('Error searching customers:', error);
                setCustomerSearchResults([]);
                setShowCustomerDropdown(false);
            } finally {
                setSearchingCustomer(false);
            }
        }, 250),
        [shopId]
    );

    // Product search - EXACT SAME as sell.js
    const searchProducts = useCallback(
        debounce(async (searchTerm) => {
            if (!searchTerm || searchTerm.length < 2 || !user?.username || !shopId) {
                setFilteredProducts([]);
                setShowProductDropdown(false);
                return;
            }

            setSearchingProducts(true);

            try {
                const response = await fetch('https://ourzestapp.online/oz_backend/sell.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        action: 'search_products',
                        searchTerm: searchTerm,
                        username: user.username,
                        shop_id: shopId
                    })
                });

                const data = await response.json();
                if (data.status === 'success') {
                    setFilteredProducts(data.data || []);
                    setShowProductDropdown(data.data && data.data.length > 0);
                } else {
                    setFilteredProducts([]);
                    setShowProductDropdown(false);
                }
            } catch (error) {
                console.error('Error searching products:', error);
                setFilteredProducts([]);
                setShowProductDropdown(false);
            } finally {
                setSearchingProducts(false);
            }
        }, 250),
        [user?.username, shopId]
    );

    // Select customer - EXACT SAME as sell.js
    const selectCustomer = (customer) => {
        setFormData(prev => ({
            ...prev,
            customer_id: customer.customerid,
            customer_name: customer.customer_name,
            customer_phone: customer.phone || '',
            customer_address: customer.address || ''
        }));
        setShowCustomerDropdown(false);
        setCustomerSearchResults([]);
        showToast('success', `${translations?.customerSelected || 'Customer selected'}: ${customer.customer_name}`);
    };

    const handleProductSelect = (product) => {
        const existingItemIndex = formData.items.findIndex(item => item.product_id === product.id);

        if (existingItemIndex >= 0) {
            const updatedItems = [...formData.items];
            const currentQty = parseFloat(updatedItems[existingItemIndex].quantity) || 0;
            const maxQty = parseFloat(product.quantity);

            if (currentQty + 1 <= maxQty) {
                updatedItems[existingItemIndex].quantity = (currentQty + 1).toString();
                setFormData(prev => ({ ...prev, items: updatedItems }));
                showToast('success', `Added another ${product.product_name}`);
            } else {
                showToast('error', `Cannot add more than available stock (${maxQty} ${product.unit})`);
            }
        } else {
            const newItem = {
                product_id: product.id,
                product_name: product.product_name,
                batch_no: product.batch_no,
                barcode: product.barcode,
                unit: product.unit,
                price: product.sell_price || product.price,
                quantity: '1',
                total: product.price,
                available_stock: product.quantity,
                quantity_alert: product.quantity_alert
            };

            setFormData(prev => ({
                ...prev,
                items: [...prev.items, newItem]
            }));

            showToast('success', `${product.product_name} added to cart`);
        }

        setProductSearchTerm('');
        setShowProductDropdown(false);
    };

    const handleItemChange = (index, field, value) => {
        const updatedItems = [...formData.items];
        updatedItems[index] = {
            ...updatedItems[index],
            [field]: value
        };

        if (field === 'quantity') {
            const qty = parseFloat(value) || 0;
            const maxQty = parseFloat(updatedItems[index].available_stock) || 0;

            if (qty > maxQty) {
                setErrors(prev => ({
                    ...prev,
                    [`quantity_${index}`]: translations?.quantityExceedsStock || 'Quantity exceeds available stock'
                }));
            } else {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[`quantity_${index}`];
                    return newErrors;
                });
            }
        }

        setFormData(prev => ({
            ...prev,
            items: updatedItems
        }));

        if (errors[`${field}_${index}`]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[`${field}_${index}`];
                return newErrors;
            });
        }
    };

    const addItem = () => {
        if (productSearchRef.current) {
            const input = productSearchRef.current.querySelector('input');
            if (input) input.focus();
        }
    };

    const removeItem = (index) => {
        if (formData.items.length > 1) {
            const updatedItems = [...formData.items];
            updatedItems.splice(index, 1);
            setFormData(prev => ({
                ...prev,
                items: updatedItems
            }));

            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[`quantity_${index}`];
                return newErrors;
            });
        }
    };

    const calculateTotals = () => {
        let subtotal = 0;
        formData.items.forEach(item => {
            const price = parseFloat(item.price) || 0;
            const quantity = parseFloat(item.quantity) || 0;
            subtotal += price * quantity;
        });

        const taxPercent = parseFloat(formData.tax_percent) || 0;
        const taxAmount = subtotal * (taxPercent / 100);
        
        let discountAmount = 0;
        if (formData.discount_type === 'percentage') {
            discountAmount = subtotal * (parseFloat(formData.discount_percent) / 100);
        } else {
            discountAmount = parseFloat(formData.discount) || 0;
        }
        
        const shippingAmount = parseFloat(formData.shipping) || 0;
        const grandTotal = subtotal + taxAmount - discountAmount + shippingAmount;
        const amountPaid = parseFloat(formData.amount_paid) || 0;
        const balanceDue = grandTotal - amountPaid;
        const paymentStatus = balanceDue <= 0 ? 'paid' : (amountPaid > 0 ? 'partial' : 'unpaid');

        setFormData(prev => ({
            ...prev,
            subtotal: subtotal.toFixed(2),
            tax: taxAmount.toFixed(2),
            discount: discountAmount.toFixed(2),
            grand_total: grandTotal.toFixed(2),
            balance_due: balanceDue.toFixed(2),
            payment_status: paymentStatus
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.items || formData.items.length === 0) {
            newErrors.items = translations?.itemsRequired || 'At least one item is required';
        } else {
            formData.items.forEach((item, index) => {
                const qty = parseFloat(item.quantity) || 0;
                const maxQty = parseFloat(item.available_stock) || 0;

                if (qty > maxQty) {
                    newErrors[`quantity_${index}`] = translations?.quantityExceedsStock || 'Quantity exceeds available stock';
                }

                if (qty <= 0) {
                    newErrors[`quantity_${index}`] = translations?.invalidQuantity || 'Please enter a valid quantity';
                }

                const price = parseFloat(item.price) || 0;
                if (price <= 0) {
                    newErrors[`price_${index}`] = translations?.invalidPrice || 'Please enter a valid price';
                }
            });
        }

        if (!formData.employee_id) {
            newErrors.employee = translations?.selectEmployee || 'Please select an employee';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === 'customer_name') {
            searchCustomers(value);
        }

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handlePaidAmountChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({ ...prev, amount_paid: value }));

        const paid = parseFloat(value) || 0;
        const grandTotal = parseFloat(formData.grand_total) || 0;
        const balance = grandTotal - paid;

        setFormData(prev => ({
            ...prev,
            balance_due: balance.toFixed(2),
            payment_status: balance <= 0 ? 'paid' : (paid > 0 ? 'partial' : 'unpaid')
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!shopId) {
            showToast('error', translations?.noShopSelected || 'No shop selected. Please select a shop first.');
            return;
        }

        if (!validateForm()) {
            const firstError = document.querySelector('.has-error, .error-message-modern');
            if (firstError) {
                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
        }

        setSaving(true);

        try {
            const currentUsername = user?.username || '';
            if (!currentUsername) {
                throw new Error("User not authenticated");
            }

            const action = isEditMode ? 'edit' : 'add';
            const endpoint = 'https://ourzestapp.online/oz_backend/pos_orders.php';

            const payload = {
                action: action,
                username: currentUsername,
                shop_id: shopId,
                ...formData,
                items: formData.items.map(item => ({
                    product_id: item.product_id,
                    product_name: item.product_name,
                    batch_no: item.batch_no,
                    barcode: item.barcode,
                    unit: item.unit,
                    quantity: parseFloat(item.quantity),
                    price: parseFloat(item.price),
                    total: parseFloat(item.price) * parseFloat(item.quantity)
                }))
            };

            if (isEditMode && orderId) {
                payload.id = orderId;
            }

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.status === 'success') {
                const successMessage = isEditMode
                    ? translations?.saleUpdated || 'Order updated successfully!'
                    : translations?.orderPlaced || 'Order placed successfully!';

                showToast('success', successMessage);

                if (!isEditMode) {
                    setFormData(prev => ({
                        ...prev,
                        customer_id: null,
                        customer_name: '',
                        customer_phone: '',
                        customer_address: '',
                        employee_id: null,
                        employee_name: '',
                        subtotal: '0.00',
                        tax: '0.00',
                        tax_percent: '0.00',
                        discount: '0.00',
                        discount_percent: '0.00',
                        shipping: '0.00',
                        grand_total: '0.00',
                        amount_paid: '0.00',
                        balance_due: '0.00',
                        notes: '',
                        items: []
                    }));
                    
                    const date = new Date();
                    const newInvoiceNo = `INV-${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`;
                    setFormData(prev => ({ ...prev, invoice_no: newInvoiceNo }));
                }

                setErrors({});

                if (onSuccess) {
                    onSuccess(data.order_id);
                }
            } else {
                showToast('error', data.message || (isEditMode ? translations?.failedUpdate : translations?.orderFailed) || 'Failed to place order');
            }
        } catch (error) {
            showToast('error', error.message || translations?.networkError || 'Network error occurred');
        } finally {
            setSaving(false);
        }
    };

    const handleClear = () => {
        setFormData(prev => ({
            ...prev,
            customer_id: null,
            customer_name: '',
            customer_phone: '',
            customer_address: '',
            employee_id: null,
            employee_name: '',
            subtotal: '0.00',
            tax: '0.00',
            tax_percent: '0.00',
            discount: '0.00',
            discount_percent: '0.00',
            shipping: '0.00',
            grand_total: '0.00',
            amount_paid: '0.00',
            balance_due: '0.00',
            notes: '',
            items: []
        }));
        setProductSearchTerm('');
        setErrors({});
        setIsEditMode(false);
        
        const date = new Date();
        const newInvoiceNo = `INV-${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`;
        setFormData(prev => ({ ...prev, invoice_no: newInvoiceNo }));
    };

    const selectEmployee = (employee) => {
        setFormData(prev => ({
            ...prev,
            employee_id: employee.employeeid,
            employee_name: employee.employee_name
        }));
        setErrors(prev => ({ ...prev, employee: '' }));
    };

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return 'Rs. 0.00';
        return `Rs. ${parseFloat(amount).toFixed(2)}`;
    };

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    return (
        <div className={`purchases-form-independent ${isRTL ? 'rtl' : ''} ${isTranslating ? 'translating' : ''}`}>
            {/* Toast Notification */}
            <ToastNotification
                toast={toast}
                setToast={setToast}
                translations={translations}
            />

            {/* Modern Form Header */}
            <div className="form-header-modern">
                <div className="header-content">
                    <div className="header-icon">
                        <FontAwesomeIcon icon={faShoppingCart} />
                    </div>
                    <div className="header-text">
                        <h1>{isEditMode ? (translations?.editSale || 'Edit Order') : (translations?.posOrder || 'POS Order Form')}</h1>
                        <p>{translations?.orderItems || 'Create new order'}</p>
                    </div>
                </div>
                {isTranslating && (
                    <div className="translation-indicator">
                        <FontAwesomeIcon icon={faSpinner} spin />
                        <span>Translating...</span>
                    </div>
                )}
            </div>

            {/* Modern Form */}
            <form onSubmit={handleSubmit} className="modern-form">
                {/* Order Information Section */}
                <div className="form-section">
                    <div className="section-header">
                        <h3 className="section-title">
                            <FontAwesomeIcon icon={faFileInvoice} />
                            {translations?.saleDetails || 'Order Information'}
                        </h3>
                    </div>

                    <div className="form-grid-modern">
                        <div className="form-group-modern">
                            <div className="input-container">
                                <FontAwesomeIcon icon={faFileInvoice} className="input-icon" />
                                <input
                                    type="text"
                                    id="invoice_no"
                                    value={formData.invoice_no}
                                    readOnly
                                    className="readonly-input"
                                    dir="ltr"
                                    placeholder=" "
                                />
                                <label htmlFor="invoice_no" className="input-label">
                                    {translations?.invoiceNo || 'Invoice Number'}
                                </label>
                            </div>
                        </div>

                        <div className={`form-group-modern ${errors.date ? 'has-error' : ''}`}>
                            <div className="input-container">
                                <FontAwesomeIcon icon={faCalendarAlt} className="input-icon" />
                                <input
                                    type="date"
                                    id="order_date"
                                    name="order_date"
                                    value={formData.order_date}
                                    onChange={handleChange}
                                    disabled={saving}
                                    dir="ltr"
                                    placeholder=" "
                                />
                                <label htmlFor="order_date" className="input-label">
                                    {translations?.date || 'Date'}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Customer Information Section with Search - EXACT CLASS NAMES as sell.js */}
                <div className="form-section">
                    <div className="section-header">
                        <h3 className="section-title">
                            <FontAwesomeIcon icon={faUser} />
                            {translations?.customerDetails || 'Customer Details'}
                        </h3>
                    </div>

                    <div className="form-grid-modern">
                        <div className="form-group-modern customer-search-group" ref={customerSearchRef}>
                            <div className="input-container">
                                <FontAwesomeIcon icon={faUser} className="input-icon" />
                                <input
                                    type="text"
                                    id="customer_name"
                                    name="customer_name"
                                    value={formData.customer_name}
                                    onChange={handleChange}
                                    onFocus={() => formData.customer_name.length >= 2 && setShowCustomerDropdown(true)}
                                    placeholder=" "
                                    disabled={saving}
                                    dir={isRTL ? 'rtl' : 'ltr'}
                                    autoComplete="off"
                                />
                                <label htmlFor="customer_name" className="input-label">
                                    {translations?.customerName || 'Customer Name'}
                                </label>
                                {searchingCustomer && (
                                    <div className="search-indicator">
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                    </div>
                                )}
                            </div>

                            {showCustomerDropdown && customerSearchResults.length > 0 && (
                                <div className="customer-search-dropdown">
                                    {customerSearchResults.map(customer => (
                                        <div
                                            key={customer.customerid}
                                            className="customer-search-item"
                                            onClick={() => selectCustomer(customer)}
                                        >
                                            <div className="customer-name">{customer.customer_name}</div>
                                            {customer.phone && (
                                                <div className="customer-phone">
                                                    <FontAwesomeIcon icon={faPhone} size="xs" />
                                                    {customer.phone}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="form-group-modern">
                            <div className="input-container">
                                <FontAwesomeIcon icon={faPhone} className="input-icon" />
                                <input
                                    type="tel"
                                    id="customer_phone"
                                    name="customer_phone"
                                    value={formData.customer_phone}
                                    onChange={handleChange}
                                    placeholder=" "
                                    disabled={saving}
                                    dir="ltr"
                                />
                                <label htmlFor="customer_phone" className="input-label">
                                    {translations?.customerPhone || 'Phone'}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Employee Section */}
                <div className="form-section">
                    <EmployeeSelector
                        selectedEmployee={formData.employee_id ? { employeeid: formData.employee_id, employee_name: formData.employee_name } : null}
                        onSelectEmployee={selectEmployee}
                        shopId={shopId}
                        translations={translations}
                        disabled={saving}
                    />
                    {errors.employee && <div className="error-message-modern">{errors.employee}</div>}
                </div>

                {/* Product Search Section - EXACT CLASS NAMES as sell.js */}
                <div className="form-section">
                    <div className="form-group-modern product-search-group" ref={productSearchRef}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faSearch} className="input-icon search-icon" />
                            <input
                                type="text"
                                id="product_search"
                                value={productSearchTerm}
                                onChange={(e) => {
                                    setProductSearchTerm(e.target.value);
                                    searchProducts(e.target.value);
                                }}
                                onFocus={() => productSearchTerm.length >= 2 && setShowProductDropdown(true)}
                                placeholder=" "
                                disabled={saving}
                                dir={isRTL ? 'rtl' : 'ltr'}
                                className="product-search-input"
                                autoComplete="off"
                            />
                            <label htmlFor="product_search" className="input-label">
                                {translations?.searchProducts || 'Search Products'}
                            </label>
                            {searchingProducts && (
                                <div className="search-indicator">
                                    <FontAwesomeIcon icon={faSpinner} spin />
                                </div>
                            )}
                            <button
                                type="button"
                                className="scan-barcode-btn generate-btn"
                                title={translations?.scanBarcode || 'Scan Barcode'}
                            >
                                <FontAwesomeIcon icon={faQrcode} />
                            </button>
                        </div>

                        {showProductDropdown && filteredProducts.length > 0 && (
                            <div className="product-search-dropdown">
                                {filteredProducts.map(product => (
                                    <div
                                        key={product.id}
                                        className="product-search-item"
                                        onClick={() => handleProductSelect(product)}
                                    >
                                        <div className="product-item-name">{product.product_name}</div>
                                        <div className="product-item-details">
                                            {product.batch_no && (
                                                <span><FontAwesomeIcon icon={faTag} /> {product.batch_no}</span>
                                            )}
                                            {product.barcode && (
                                                <span><FontAwesomeIcon icon={faBarcode} /> {product.barcode}</span>
                                            )}
                                        </div>
                                        <div className="product-item-price-stock">
                                            <span className="product-price">
                                                <FontAwesomeIcon icon={faRupeeSign} /> {product.price}
                                            </span>
                                            <span className={`product-stock ${parseFloat(product.quantity) <= (product.quantity_alert || 5) ? 'low-stock' : ''}`}>
                                                {translations?.stock || 'Stock'}: {product.quantity} {product.unit}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {showProductDropdown && productSearchTerm.length >= 2 && filteredProducts.length === 0 && !searchingProducts && (
                            <div className="product-search-dropdown empty">
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                <span>{translations?.noProductsFound || 'No products found'}</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Items Section */}
                {formData.items.length > 0 && (
                    <div className="form-section">
                        <ItemsTable
                            items={formData.items}
                            onItemChange={handleItemChange}
                            onRemove={removeItem}
                            onAdd={addItem}
                            errors={errors}
                            disabled={saving}
                            translations={translations}
                            isRTL={isRTL}
                        />
                    </div>
                )}

                {/* Calculations Section - EXACT CLASS NAMES as sell.js */}
                {formData.items.length > 0 && (
                    <div className="form-section">
                        <div className="section-header">
                            <h3 className="section-title">
                                <FontAwesomeIcon icon={faCalculator} />
                                {translations?.calculations || 'Calculations'}
                            </h3>
                        </div>

                        <div className="calculations-grid">
                            <div className="calculation-row grand-total">
                                <span className="calculation-label">{translations?.grandTotal || 'Grand Total'}:</span>
                                <span className="calculation-value highlight">Rs. {formData.grand_total}</span>
                            </div>

                            <div className={`calculation-row paid-field ${errors.paid ? 'has-error' : ''}`}>
                                <span className="calculation-label">{translations?.paidAmount || 'Paid Amount'}:</span>
                                <div className="paid-input-wrapper" style={{ width: '120px' }}>
                                    <input
                                        type="number"
                                        id="amount_paid"
                                        name="amount_paid"
                                        value={formData.amount_paid}
                                        onChange={handlePaidAmountChange}
                                        step="0.01"
                                        min="0"
                                        max={formData.grand_total}
                                        placeholder="0.00"
                                        disabled={saving}
                                        dir="ltr"
                                        style={{ textAlign: 'right' }}
                                    />
                                </div>
                            </div>

                            <div className="calculation-row balance">
                                <span className="calculation-label">{translations?.balance || 'Balance'}:</span>
                                <span className={`calculation-value ${parseFloat(formData.balance_due) > 0 ? 'negative' : 'positive'}`}>
                                    Rs. {formData.balance_due}
                                </span>
                            </div>

                            <div className="calculation-row">
                                <span className="calculation-label">{translations?.paymentMethod || 'Payment Method'}:</span>
                                <div className="payment-method-selector" style={{ width: '150px' }}>
                                    <select
                                        value={formData.payment_method}
                                        onChange={(e) => setFormData(prev => ({ ...prev, payment_method: e.target.value }))}
                                        disabled={saving}
                                        dir={isRTL ? 'rtl' : 'ltr'}
                                    >
                                        <option value="cash">{translations?.cash || 'Cash'}</option>
                                        <option value="card">{translations?.card || 'Card'}</option>
                                        <option value="bankTransfer">{translations?.bankTransfer || 'Bank Transfer'}</option>
                                        <option value="easyPaisa">{translations?.easyPaisa || 'EasyPaisa'}</option>
                                        <option value="jazzCash">{translations?.jazzCash || 'JazzCash'}</option>
                                        <option value="other">{translations?.other || 'Other'}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Form Actions */}
                <div className="form-actions-modern">
                    <button
                        type="button"
                        className="btn-modern btn-secondary-modern"
                        onClick={handleClear}
                        disabled={saving}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                        <span>{translations?.clear || 'Clear'}</span>
                    </button>
                    <button
                        type="submit"
                        className="btn-modern btn-primary-modern"
                        disabled={saving || isTranslating || formData.items.length === 0}
                    >
                        {saving ? (
                            <>
                                <div className="btn-spinner"></div>
                                <span>{translations?.saving || 'Saving...'}</span>
                            </>
                        ) : (
                            <>
                                <span>{isEditMode ? (translations?.updateSale || 'Update Order') : (translations?.placeOrder || 'Place Order')}</span>
                                <FontAwesomeIcon icon={faSave} />
                            </>
                        )}
                    </button>
                </div>
            </form>

            {/* Loading Overlay */}
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="loading-spinner"></div>
                        <p>{translations?.loading || 'Loading...'}</p>
                        <p className="loading-subtext">Please wait while we load order data</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PosOrderForm;